<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="dataService.loading$"
	size="md"
	[confirmButtonText]="'gl.delete'"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>{{ 'import_rates.removing_dialog' | translate }}</div>
	</h3>
	<div slot="content">
		<alaris-select2
			[alarisLoading]="sourcesService.loading$"
			[backdrop]="false"
			[expandable]="true"
			[label]="'import_rates.source' | translate"
			[formControl]="source"
			mode="string">
			<alaris-select-filter2 [formControl]="sourcesFilter"></alaris-select-filter2>
			@for (source of sources; track source) {
			<alaris-options2 [value]="source.Name">
				<span>
					{{ source.Name }}
				</span>
			</alaris-options2>
			}
		</alaris-select2>
	</div>
</alaris-dialog>
